// extracted by mini-css-extract-plugin
export default {"titleWrapper":"styles_titleWrapper__-8JAt","title":"styles_title__6veUd","boxInside":"styles_boxInside__eT51Q","noData":"styles_noData__d1lA-"};